import React from 'react';

import SliderPage from '../../components/Slider';

import './style.scss';

const AnnualReport = ({ entity }) => {
  return (
    <div className="AnnualReport">
      <SliderPage entity={entity} />
    </div>
  );
};

export default AnnualReport;
